import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { RepetitionPerformance } from "../types/ui/Repetition";
import {
  RawRepetitionResponse,
} from "../types/api/repetition";
import { getRepetitionPerformance } from "../services/ShootingData/service";
import { toRepetitionPerformances } from "../adapters/RepetitionAdapter";
import { userAtom } from "../state/atoms/authAtoms";
import { useAtomValue } from "jotai";

export interface RepetitionPerformanceResult {
  total_count: number;
  data: RepetitionPerformance[];
}

export function useRepetitionPerformance(
  sessionId: number,
  scenarioId: number,
  drillName?: string,
  repetitionNumber?: number
): UseQueryResult<RepetitionPerformanceResult, Error> {
  const userId = useAtomValue(userAtom)?.user_id!;

  return useQuery<RawRepetitionResponse, Error, RepetitionPerformanceResult>({
    queryKey: [
      "repetitions",
      userId,
      sessionId,
      scenarioId,
      drillName,
      repetitionNumber,
    ],
    queryFn: () =>
      getRepetitionPerformance(
        userId,
        sessionId,
        scenarioId,
        drillName,
        repetitionNumber
      ),
    select: (raw) => ({
      total_count: raw.total_count,
      data: toRepetitionPerformances(raw.data),
    }),
    enabled: Boolean(userId) && Boolean(sessionId) && Boolean(scenarioId),
    staleTime: 5 * 60_000,
  });
}
